<template>
  <div class="bank-id-fail">
    <Container>
      <Card padding="large">
        <b-row>
          <b-col cols="12" sm="auto" class="text-center">
            <CloseSVG class="icon h1 text-error" />
          </b-col>

          <b-col>
            <Margins>
              <h1 class="h3 text-normal">{{ $t('ACTIVITY_FAIL') }}</h1>

              <p class="text-small">{{ $t('ACTIVITY_FAIL_INFO') }}</p>

              <Separator size="large" />

              <b-row align-h="center" class="margins__double">
                <b-col cols="auto">
                  <Button
                    :disabled="isLoading"
                    @click="
                      $router.push({
                        name: ROUTES.LOAN_PAYMENT_RESERVATION_LOADING.name,
                      })
                    "
                  >
                    {{ $t('TRY_AGAIN') }}
                  </Button>
                </b-col>
              </b-row>
            </Margins>
          </b-col>
        </b-row>
      </Card>
    </Container>
  </div>
</template>

<script>
import { Container, Card, Margins, Separator, Button } from '@/components';
import CloseSVG from '@/assets/images/times-circle-regular.svg';
import { constants } from '@/mixins';
import { mapState } from 'vuex';

export default {
  name: 'Fail',
  mixins: [constants],
  components: {
    Card,
    Container,
    Margins,
    Separator,
    Button,
    CloseSVG,
  },
  computed: {
    ...mapState(['isLoading']),
  },
};
</script>
